// extracted by mini-css-extract-plugin
module.exports = {"viewTrailerButton":"h1","isRental":"h2","iconWrapper":"h3"};